var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/*
 * @Description: 登录、切换公司mixin
 */
import { Vue, Component } from 'vue-property-decorator';
import TextModal from '@/common/components/Modal/TextModal.vue';
import { _get } from '@/common/request/index';
import { removeStorage, setStorage } from '@lhb/cache';
var MixinChangeStore = /** @class */ (function (_super) {
    __extends(MixinChangeStore, _super);
    function MixinChangeStore() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // method
    /**
     * 公司切换
     * @companyId 公司id
     */
    MixinChangeStore.prototype.companyChange = function (companyId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            try {
                removeStorage('pageFilters');
                _this.$store.dispatch('$_UserSwitchCompany', { companyId: companyId }).then(function (companyInfo) {
                    _this.$store.dispatch('CrmSwitchTenant');
                    if (companyInfo.versionType === 'REQUIREMENT') {
                        _this.$router.replace({ path: '/lhb-micro-pms/business' });
                    }
                    else {
                        if (companyInfo.type === 'TYPE_EXPER') {
                            _this.$router.replace({ path: '/schedule' });
                        }
                        else {
                            _get('/property/modules').then(function (data) {
                                var returnMenu = ['/organize']; // saasadmin后台配置空菜单权限，但是还会默认返回organize菜单权限，应该是那边的bug，这里暂时先过滤掉，防止404
                                _this.$store.commit('UPDATE_MENU', data || []);
                                var menuList = data || [];
                                var path = menuList.length ? (menuList[0].children && menuList[0].children.length) ? menuList[0].children[0].uri : menuList[0].uri : '/schedule';
                                _this.$router.replace({ path: returnMenu.includes(path) ? '/schedule' : path });
                            });
                        }
                    }
                    setStorage('store', _this.$store.state);
                    // await this.$store.dispatch('getAuth'); // 获取wkcrm权限
                    // await this.$store.dispatch('QueryModules');
                    // @ts-ignore
                    window.$_EventLib.dispatch('LOADING', null);
                    resolve(true);
                }, function (err) {
                    reject(err);
                });
            }
            catch (err) {
                console.log("err = ", err);
                reject(err);
            }
        });
    };
    MixinChangeStore.prototype.beforeClose = function () {
        return this.$router.replace({ path: '/lhb-micro-pms/placeMng' });
    };
    MixinChangeStore = __decorate([
        Component({
            name: 'MixinChangeStore',
            components: {
                TextModal: TextModal,
            },
        })
    ], MixinChangeStore);
    return MixinChangeStore;
}(Vue));
export default MixinChangeStore;
